import { render, staticRenderFns } from "./detailsView.vue?vue&type=template&id=2e7948fa&scoped=true"
import script from "./detailsView.vue?vue&type=script&lang=js"
export * from "./detailsView.vue?vue&type=script&lang=js"
import style0 from "./detailsView.vue?vue&type=style&index=0&id=2e7948fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7948fa",
  null
  
)

export default component.exports